import { ApolloClient, ApolloLink, defaultDataIdFromObject, from, InMemoryCache } from '@apollo/client';
import cleanMutationLink from './getApolloCleanMutationLink';
import httpLink from './getApolloHttpLink';
import { createSentryGraphqlClientLink } from './sentryGraphqlClientLink';

const getApolloClient = async (tokenLink: ApolloLink) => {
  return new ApolloClient({
    link: from([cleanMutationLink, createSentryGraphqlClientLink(), tokenLink, httpLink]),
    cache: new InMemoryCache({
      addTypename: true,
      typePolicies: {
        MasterDataCountryTranslation: { keyFields: ['_id', 'name'] },
        MasterDataCitizenship: { keyFields: ['_id', 'name'] },
        MasterDataCitizenshipTranslation: { keyFields: ['code', 'name'] },
      },
      dataIdFromObject: (responseObject) => {
        return responseObject?._id && typeof responseObject._id === 'string' && responseObject.__typename
          ? `${responseObject.__typename}:${responseObject._id}`
          : defaultDataIdFromObject(responseObject);
      },
    }),
  });
};

export default getApolloClient;
